import api from '../../../api'

const mapPrintMachine = printMachine => {
  return {
    id: printMachine.id,
    name: printMachine.name,
    printWidth: printMachine.printWidth,
    printHeight: printMachine.printHeight,
    printPreSize: printMachine.printPreWidth,
    currencyRate: printMachine.currencyRate,
    multiplier: printMachine.multiplier,
    description: printMachine.description,
    enabled: printMachine.enabled,
    overview: `формат печати: ${printMachine.printWidth}х${
      printMachine.printHeight
    } мм, припуски: ${printMachine.printPreWidth} мм, курс валюты: ${
      printMachine.currencyRate
    }, коэфф. рассчета: ${printMachine.multiplier}`
  }
}

export default {
  name: 'PrintMachinesIndex',
  data: () => {
    return {
      printMachines: []
    }
  },
  methods: {
    loadPrintMachines () {
      api.get
        .printMachines()
        .then(resp => {
          this.printMachines = resp.data.data.printMachines
            .map(mapPrintMachine)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    }
  },
  created: function () {
    this.loadPrintMachines()
    this.$eventBus.$on('updatePrintMachines', () => {
      this.loadPrintMachines()
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки ПМ')
    })
  }
}
